
import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";

interface TermsAgreementProps {
  agreedToTerms: boolean;
  setAgreedToTerms: (agreed: boolean) => void;
}

const TermsAgreement = ({ agreedToTerms, setAgreedToTerms }: TermsAgreementProps) => {
  return (
    <div className="flex items-start space-x-2">
      <Checkbox
        id="terms"
        checked={agreedToTerms}
        onCheckedChange={(checked) => setAgreedToTerms(checked === true)}
      />
      <label
        htmlFor="terms"
        className="text-sm text-gray-700 dark:text-gray-300 cursor-pointer"
      >
        I confirm that all information provided is accurate and that the uploaded documents are authentic. 
        I understand that submitting false information may result in the rejection of my verification 
        request and possible account suspension.
      </label>
    </div>
  );
};

export default TermsAgreement;
